import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Divider, FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  title: {
    fontSize: '13px',
    fontWeight: '500'
  },
  value: {
    whitSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
});

function ReadItem(info) {
  const classes = useStyles();
  return (
    <>
      <span className={classes.title}>{info.label}</span>
      <p className={classes.value}>{info.readValue}</p>
    </>
  );
}

export default function NCNormal(props) {
  const { DocType, setDocType } = props;
  const { document, isSaving } = props;
  const [reasons, setReasons] = useState([]);

  async function listReasons() {
    let response = await wsFindBy('base/reason', 'group', '2');
    if (response.success) setReasons(response.data);
  }
  useEffect(() => {
    listReasons();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} lg={12}>
        <h5 style={{ fontWeight: 400 }}>Nota de crédito</h5>
        <Divider style={{ marginTop: '5px', marginBottom: '10px' }} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small" required>
          <InputLabel>Tipo documento</InputLabel>
          <Select value={DocType} onChange={(e) => setDocType(e.target.value)}>
            <MenuItem value="I">Producto</MenuItem>
            <MenuItem value="S">Concepto</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Zona" readValue={document.base_zone_description} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Vendedor" readValue={document.SlpName} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Cliente" readValue={document.CardName} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Dirección" readValue={document.Address2} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Término pago" readValue={document.PymntGroup} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="Canal" readValue={document.base_canal_description} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem label="% Descuento" readValue={document.DiscPrcnt} />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem
          label="Monto bruto"
          readValue={currency(document.gross_amount || 0 - document.amount_Exclude)}
        />
      </GridItem>
      <GridItem xs={12} md={4} lg={2}>
        <ReadItem
          label="Monto total"
          readValue={currency(document.DocTotal || 0 - document.amount_Exclude)}
        />
      </GridItem>
      <GridItem xs={12} lg={2}>
        <FormControl
          fullWidth
          margin="normal"
          size="small"
          required
          key={reasons}
          style={{ marginTop: 0 }}
        >
          <InputLabel>Razón prioridad</InputLabel>
          <Select
            defaultValue={document.base_reason_id_priority || '8'}
            inputProps={{
              name: 'base_reason_id_priority',
            }}
            disabled={isSaving}
          >
            {reasons.map((item, i) => {
              return (
                <MenuItem value={item.id} key={i}>
                  {item.description}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {/* <TextField
          multiline
          ref={commentRef}
          label="Comentario"
          fullWidth
          name="comment"
          margin="normal"
          size="small"
          defaultValue={document.comment}
        /> */}
      </GridItem>
    </GridContainer>
  );
}
